if (!customElements.get('recently-viewed')) {
  customElements.define(
     'recently-viewed',
              class RecentlyViewed extends HTMLElement {
                constructor() {
                  super();
                  this.bindEvents();
                }
              
                    bindEvents(){
                         const main_wapper  = this.querySelector('.swiper-main-wrapper');
                         const product_hendle = this.getAttribute('data-product-handle');
                         const this_obj = this;
                         const gridItemWidth = this.getAttribute('data-grid-item-class');
                         const rowOf = this.getAttribute('data-row-of');
                         const images_size = this.getAttribute('data-image-sizes');
                         const enable_quick_add = this.getAttribute('data-quick_add_btn');


                         var promises = [];

                      // collect handles (skip falsy/undefined)
                      Object.keys(theme.recentlyViewed.recent).forEach(function (handle) {
                        if (handle && handle !== 'undefined') {
                          promises.push(getProductInfo(handle));
                        }
                      });


                      Promise.all(promises).then(function(productsHTML) {
                        // Create container (only HTML)
                        
                        var container = document.createElement('div');
                        container.className = 'swiper recently-viewed-swiper';

                        // Create the wrapper that will hold ALL slides
                        var wrapper = document.createElement('div');
                        wrapper.className = 'swiper-wrapper';

                        // Add each product HTML inside one slide
                        productsHTML.forEach(function(productHTML) {
                            const html = new DOMParser().parseFromString(productHTML, 'text/html');
                          if(html.body.classList.contains('template-404')) return;
                          var slide = document.createElement('div');
                          slide.className = 'swiper-slide';
                          slide.innerHTML = productHTML; // productHTML expected to be safe HTML returned by your /products/...?view=cart
                          wrapper.appendChild(slide);
                        });

                        // Append wrapper to container
                        container.appendChild(wrapper);

                      console.log("container",container);
                        main_wapper.appendChild(container);

                        const sliderOptions = this_obj.getAttribute('data-slider-options');
                          if (sliderOptions){
                            const slideroptionConfig = JSON.parse(sliderOptions),
                            recommedndationSlider = new Swiper(".recently-viewed-swiper", slideroptionConfig);
                          }

                          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

                      });
                       // your existing getProductInfo (unchanged)
                      function getProductInfo(handle) {
                        return new Promise(function(resolve, reject) {
                          if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
                            resolve(theme.recentlyViewed.productInfo[handle]);
                          } else {
                            fetch('/products/' + handle + '?view=card')
                              .then(function(response) {return response.text();})
                              .then(function(product) { resolve(product); })
                              .catch(reject);
                          }
                        });
                      }
                    }
              }
  );
}